import React from 'react';
import { GridContainer, Grid } from '../../shared/grid';

export const About: React.FC = () =>{
  return(
  <GridContainer className="margin-top-6">
      <Grid row gap="md">
      <Grid
        desktop={{col:12}}
        className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3">
            <span className="font-sans-2xl text-bold">FEMS About</span>
        </Grid>
      </Grid>

      <Grid row gap="lg" id={'data-sets'}>
        <Grid desktop={{col:12}} className="padding-bottom-2">
          <span className="font-sans-md text-bold">FEMS Version 3.7.2</span>
        </Grid>
        <Grid desktop={{col:12}} className="padding-bottom-2">
        For more detailed information about the Fire Environment Mapping System (FEMS), please visit the following link which will provide general information and user support materials:&nbsp;<a href="https://www.wildfire.gov/application/fems" target="__blank" rel="noopener noreferrer">https://www.wildfire.gov/application/fems</a> 
        </Grid>
      </Grid>
  </GridContainer>
  )
}
